import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class UtilsService {
  static getPhoneCodes(params) {
    return HttpUtil.get(API_ROUTES.UTILS.PHONECODESAPI);
  }

  static getCountryList() {
    return HttpUtil.get(API_ROUTES.UTILS.COUNTRYLISTAPI);
  }

  static getStateList(countryId) {
    return HttpUtil.get(API_ROUTES.UTILS.STATELISTAPI+`?countryId=${countryId}`);
  }

  static getCurrencyList() {
    return HttpUtil.get(API_ROUTES.UTILS.CURRENCYLISTAPI);
  }
}
